import Splitting from "splitting";
import LazyLoad from "vanilla-lazyload"; // Code from media-lazy-loader.js. Will be removed once that module actually initialises and works correctly.

export default class SplitText {
    constructor() {
        Splitting();

        // Code from media-lazy-loader.js. Will be removed once that module actually initialises and works correctly.
        const lazyLoadOptions = {
            elements_selector: ".lazy",
        };
        const pageLazyLoad = new LazyLoad(lazyLoadOptions);
    }
}
